/*
  Koeln checkout redirect.
  Decides via SKU-prefix whether the cart should check out on dus.colognewatch.de.

  SKU convention (Cologne Watch):
    - AD*, KD*  -> Duesseldorf (Ankauf/Kommission DUS)
    - AK*, KK*  -> Koeln (Ankauf/Kommission Koeln)

  Cart policy: each cart contains exactly one product (enforced upstream).
  No Cloudways backend call; variant-id mapping happens on the DUS loading page
  via /products/<handle>.js using the SKU we pass through.
*/
$(document).ready(function () {
  var DUS_CHECKOUT_URL = "https://dus.colognewatch.de/pages/loading-page";
  var CHECKOUT_SELECTOR = ".cart__checkout-button, button[form='mini-cart-form']";
  var DUS_SKU_PREFIXES = ["AD", "KD"];

  var DECISION_LOADING = "loading";
  var DECISION_REDIRECT = "redirect";
  var DECISION_NORMAL = "normal";
  var DECISION_BLOCKED = "blocked";

  var decisionState = DECISION_LOADING;
  var redirectUrl = null;
  var blockMessage = null;
  var redirectInProgress = false;
  var pendingButton = null;
  var nativeCheckoutInProgress = false;

  function isEnglishLocale() {
    return !!(
      window.Shopify &&
      Shopify.locale &&
      String(Shopify.locale).toLowerCase().indexOf("en") === 0
    );
  }

  // Texte kommen aus den Sprachdateien (snippets/js-variables.liquid). Die festen
  // Texte bleiben nur als Rückfallebene, falls themeVariables nicht geladen ist.
  function getLocalizedString(name) {
    var strings = window.themeVariables && window.themeVariables.strings;
    return strings && typeof strings[name] === "string" && strings[name] ? strings[name] : null;
  }

  function getBlockedMessage(reason) {
    var localized = getLocalizedString(reason === "mixed" ? "cwCheckoutMixedCart" : "cwCheckoutLocationUnverified");
    if (localized) return localized;

    if (reason === "mixed") {
      return isEnglishLocale()
        ? "This cart contains a Duesseldorf watch together with another item. Please check out this watch separately."
        : "Dieser Warenkorb enthält eine Düsseldorf-Uhr zusammen mit einem weiteren Artikel. Bitte legen Sie diese Uhr einzeln in den Warenkorb.";
    }

    return isEnglishLocale()
      ? "We could not safely verify the correct checkout location. Please reload the cart and try again."
      : "Der richtige Checkout-Standort konnte nicht sicher geprüft werden. Bitte laden Sie den Warenkorb neu und versuchen Sie es erneut.";
  }

  function getCookieValue(cookieName) {
    var prefix = cookieName + "=";
    var parts = document.cookie ? document.cookie.split("; ") : [];

    for (var i = 0; i < parts.length; i += 1) {
      if (parts[i].indexOf(prefix) === 0) {
        return parts[i].substring(prefix.length);
      }
    }

    return null;
  }

  // ===== Anzeigen-Parameter für die Sitzung merken =====
  // Kunden landen über eine Anzeige meist auf einer Produktseite. Beim Klick auf
  // "Zur Kasse" steht gclid/utm_* nicht mehr in der Warenkorb-URL, deshalb werden
  // sie beim Seitenaufruf gemerkt – nur mit Cookie-Zustimmung und nur für die Sitzung.
  // Werbe-Kennungen brauchen Marketing-Zustimmung, UTM-Werte reicht Statistik-Zustimmung.
  var STORED_TRACKING_KEY = "cwCheckoutTrackingParams";
  var AD_CLICK_PARAMS = ["gclid", "gbraid", "wbraid", "gad_source", "gad_campaignid"];
  var UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id"];
  var SESSION_TRACKING_PARAMS = AD_CLICK_PARAMS.concat(UTM_PARAMS);

  function getSessionStorage() {
    try {
      return window.sessionStorage || null;
    } catch (error) {
      return null;
    }
  }

  function privacyAllows(name) {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy[name] === "function" && privacy[name]());
    } catch (error) {
      return false;
    }
  }

  function marketingConsent() {
    return privacyAllows("marketingAllowed");
  }

  function analyticsConsent() {
    return marketingConsent() || privacyAllows("analyticsProcessingAllowed");
  }

  function isAdClickParam(param) {
    return AD_CLICK_PARAMS.indexOf(param) !== -1;
  }

  function readStoredTrackingParams() {
    var storage = getSessionStorage();
    if (!storage) return {};
    try {
      var stored = JSON.parse(storage.getItem(STORED_TRACKING_KEY) || "{}");
      return stored && typeof stored === "object" && !Array.isArray(stored) ? stored : {};
    } catch (error) {
      return {};
    }
  }

  function writeStoredTrackingParams(values) {
    var storage = getSessionStorage();
    if (!storage) return;
    try {
      if (Object.keys(values).length) storage.setItem(STORED_TRACKING_KEY, JSON.stringify(values));
      else storage.removeItem(STORED_TRACKING_KEY);
    } catch (error) {
      // Speicher voll oder gesperrt: Weiterleitung funktioniert trotzdem.
    }
  }

  // Gespeicherte Werte nur behalten, soweit die aktuelle Zustimmung sie deckt (Widerruf).
  function pruneStoredTrackingParams() {
    var stored = readStoredTrackingParams();
    var marketing = marketingConsent();
    var analytics = analyticsConsent();
    var kept = {};
    Object.keys(stored).forEach(function (param) {
      if (SESSION_TRACKING_PARAMS.indexOf(param) === -1 || typeof stored[param] !== "string") return;
      if (isAdClickParam(param) ? marketing : analytics) kept[param] = stored[param];
    });
    if (Object.keys(kept).length !== Object.keys(stored).length) writeStoredTrackingParams(kept);
    return kept;
  }

  function rememberTrackingParams() {
    var marketing = marketingConsent();
    if (!analyticsConsent()) {
      writeStoredTrackingParams({});
      return;
    }

    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (error) {
      return;
    }
    var found = {};
    var hasValue = false;
    SESSION_TRACKING_PARAMS.forEach(function (param) {
      if (isAdClickParam(param) && !marketing) return;
      var value = params.get(param);
      if (value) {
        found[param] = value.slice(0, 500);
        hasValue = true;
      }
    });

    // Neuer Anzeigenklick ersetzt den alten vollständig (letzter Klick zählt).
    if (hasValue) writeStoredTrackingParams(found);
    else pruneStoredTrackingParams();
  }

  // Google speichert den Anzeigenklick nach Zustimmung im Cookie _gcl_aw ("GCL.<Zeit>.<gclid>").
  // Bei mehreren Cookies (Host- und Domain-Cookie) gewinnt der neueste Klick.
  function getGclidFromCookie() {
    var parts = document.cookie ? document.cookie.split("; ") : [];
    var best = null;
    var bestTime = -1;
    for (var i = 0; i < parts.length; i += 1) {
      if (parts[i].indexOf("_gcl_aw=") !== 0) continue;
      var segments;
      try {
        segments = decodeURIComponent(parts[i].substring(8)).split(".");
      } catch (error) {
        continue;
      }
      var time = parseInt(segments[1], 10);
      if (segments.length < 3 || segments[0] !== "GCL" || !segments[2]) continue;
      if ((isNaN(time) ? 0 : time) > bestTime) {
        bestTime = isNaN(time) ? 0 : time;
        best = segments.slice(2).join(".");
      }
    }
    return best;
  }

  // Die Consent-API wird vom Cookie-Banner asynchron nachgeladen und fehlt beim
  // jQuery-ready meist noch. Darum auf das Laden warten (Event plus kurzes Polling).
  function whenPrivacyApiReady(callback) {
    var done = false;
    var tries = 0;
    var timer = null;
    function run() {
      if (done || !(window.Shopify && window.Shopify.customerPrivacy)) return false;
      done = true;
      if (timer) window.clearInterval(timer);
      callback();
      return true;
    }
    if (run()) return;
    if (typeof document.addEventListener === "function") {
      document.addEventListener("consentTrackingApiLoaded", run);
    }
    if (typeof window.setInterval === "function") {
      timer = window.setInterval(function () {
        tries += 1;
        if (!run() && tries >= 40) window.clearInterval(timer); // max. ca. 10 s
      }, 250);
    }
  }

  whenPrivacyApiReady(rememberTrackingParams);
  if (typeof document.addEventListener === "function") {
    // Feuert bei jeder Änderung der Zustimmung, auch bei Widerruf.
    document.addEventListener("visitorConsentCollected", rememberTrackingParams);
  }

  // ===== Cookie-Entscheidung an Düsseldorf übergeben =====
  // Gleiche Marke, eigener Shop: Die im Kölner Banner getroffene Entscheidung gilt laut
  // Banner-Text auch für den Checkout in Düsseldorf. Übertragen wird nur eine echte
  // Entscheidung (yes/no), nie ein Standardwert. Format: m<0|1>a<0|1>p<0|1>.
  function getConsentTransferParam() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.currentVisitorConsent !== "function") return null;
      var current = privacy.currentVisitorConsent() || {};
      var flags = { m: current.marketing, a: current.analytics, p: current.preferences };
      var value = "";
      var keys = ["m", "a", "p"];
      for (var i = 0; i < keys.length; i += 1) {
        if (flags[keys[i]] === "yes") value += keys[i] + "1";
        else if (flags[keys[i]] === "no") value += keys[i] + "0";
        else return null;
      }
      return value;
    } catch (error) {
      return null;
    }
  }

  function isDusSku(sku) {
    if (!sku) {
      return false;
    }

    var upper = String(sku).trim().toUpperCase();
    for (var i = 0; i < DUS_SKU_PREFIXES.length; i += 1) {
      if (upper.indexOf(DUS_SKU_PREFIXES[i]) === 0) {
        return true;
      }
    }

    return false;
  }

  function buildRedirectUrl(dusItems) {
    var checkoutUrl = new URL(DUS_CHECKOUT_URL);

    $.each(dusItems, function (index, item) {
      if (!item) {
        return;
      }

      checkoutUrl.searchParams.append("h", item.handle);
      checkoutUrl.searchParams.append("sku", item.sku);
      checkoutUrl.searchParams.append("q", item.quantity);
    });

    // ===== Tracking-Parameter für Cross-Domain Tracking =====
    var currentParams = new URLSearchParams(window.location.search);
    var trackingParams = ["fbclid"].concat(SESSION_TRACKING_PARAMS, ["_ga", "_gl"]);

    // Satz-Logik: Werte stammen entweder alle aus der URL oder alle aus dem Speicher,
    // damit Klick-ID und UTM-Quelle nie aus verschiedenen Besuchen gemischt werden.
    var urlHasSet = SESSION_TRACKING_PARAMS.some(function (param) {
      return !!currentParams.get(param);
    });
    var storedParams = urlHasSet ? {} : pruneStoredTrackingParams();
    var sourceParams = urlHasSet ? currentParams : { get: function (param) { return storedParams[param] || null; } };

    trackingParams.forEach(function (param) {
      var value = SESSION_TRACKING_PARAMS.indexOf(param) !== -1 ? sourceParams.get(param) : currentParams.get(param);
      if (value) {
        checkoutUrl.searchParams.append(param, value);
      }
    });

    // Fallback: gclid aus dem Google-Cookie, nur mit Marketing-Zustimmung und nur,
    // wenn kein anderer Besuch mit eigener Quelle (UTM/Klick-ID) bekannt ist.
    if (!urlHasSet && !Object.keys(storedParams).length && marketingConsent()) {
      var cookieGclid = getGclidFromCookie();
      if (cookieGclid) checkoutUrl.searchParams.append("gclid", cookieGclid);
    }

    var consentParam = getConsentTransferParam();
    if (consentParam) {
      checkoutUrl.searchParams.append("cw_consent", consentParam);
    }

    // ===== Meta _fbc/_fbp: aus der URL immer, aus Cookies nur mit Marketing-Zustimmung =====
    var allowMetaCookies = marketingConsent();
    var fbcValue = currentParams.get("_fbc") || (allowMetaCookies ? getCookieValue("_fbc") : null);
    if (fbcValue) {
      checkoutUrl.searchParams.append("_fbc", fbcValue);
    }

    var fbpValue = currentParams.get("_fbp") || (allowMetaCookies ? getCookieValue("_fbp") : null);
    if (fbpValue) {
      checkoutUrl.searchParams.append("_fbp", fbpValue);
    }
    // ===== Ende Tracking-Parameter =====

    return checkoutUrl.toString();
  }

  function setButtonsBusy(isBusy) {
    var $buttons = $(CHECKOUT_SELECTOR);

    $buttons.prop("disabled", !!isBusy).attr("aria-busy", !!isBusy ? "true" : "false");

    if (isBusy) {
      $buttons.attr("aria-disabled", "true");
    } else {
      $buttons.removeAttr("aria-disabled");
    }
  }

  function blockCheckout(message) {
    setButtonsBusy(false);
    redirectInProgress = false;
    pendingButton = null;

    if (message) {
      window.alert(message);
    }
  }

  function continueWithNativeCheckout(buttonElement) {
    var formElement = null;

    if (buttonElement && buttonElement.form) {
      formElement = buttonElement.form;
    } else if (buttonElement) {
      formElement = $(buttonElement).closest("form").get(0);
    }

    if (formElement) {
      nativeCheckoutInProgress = true;
      window.setTimeout(function () {
        nativeCheckoutInProgress = false;
      }, 1500);

      if (typeof formElement.requestSubmit === "function") {
        if (buttonElement && buttonElement.form === formElement) {
          formElement.requestSubmit(buttonElement);
        } else {
          formElement.requestSubmit();
        }
      } else {
        formElement.submit();
      }
      return;
    }

    var checkoutPath =
      window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root + "checkout"
        : "/checkout";

    window.location.href = checkoutPath;
  }

  function redirectToDusCheckout() {
    if (redirectInProgress) {
      return;
    }

    redirectInProgress = true;
    setButtonsBusy(true);

    if (!redirectUrl) {
      blockCheckout(getBlockedMessage("unverified"));
      return;
    }

    var destination = redirectUrl;
    var controller = new AbortController();
    var completed = false;
    var timeout = window.setTimeout(function () {
      controller.abort();
      continueToDus();
    }, 8000);

    function continueToDus() {
      if (completed) return;
      completed = true;
      window.clearTimeout(timeout);
      // Keep the established clear-failure policy: use the already verified DUS route.
      window.location.href = destination;
    }

    fetch("/cart/clear.js", {
      method: "POST",
      signal: controller.signal,
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      // Complete the body before navigation so cart observers can finish their cloned response.
      return response.text();
    }).then(continueToDus, continueToDus);
  }

  function loadDecision() {
    var deferred = $.Deferred();

    decisionState = DECISION_LOADING;
    redirectUrl = null;
    blockMessage = null;

    $.ajax({
      type: "GET",
      url: "/cart.json",
      cache: false,
      timeout: 8000,
      dataType: "json",
    })
      .done(function (cartData) {
        var validCart = cartData && typeof cartData === "object" && !Array.isArray(cartData) && Array.isArray(cartData.items);
        var items = validCart ? cartData.items : [];
        if (!validCart || !items.every(function (item) {
          return item && typeof item === "object" && !Array.isArray(item) &&
            typeof item.handle === "string" && item.handle.trim().length > 0 &&
            (item.sku === null || typeof item.sku === "string") &&
            Number.isSafeInteger(item.quantity) && item.quantity > 0;
        })) {
          decisionState = DECISION_BLOCKED;
          blockMessage = getBlockedMessage("unverified");
          deferred.resolve();
          return;
        }
        var dusItems = [];
        var invalidDusItem = false;

        $.each(items, function (index, item) {
          if (!item || !isDusSku(item.sku)) {
            return;
          }

          if (!item.handle || !item.sku) {
            invalidDusItem = true;
            return false;
          }

          dusItems.push({
            handle: item.handle,
            sku: item.sku,
            quantity: item.quantity,
          });
        });

        if (invalidDusItem) {
          if (window.console && console.warn) {
            console.warn("localized-checkout: DUS cart item is missing handle or SKU; blocking checkout");
          }

          decisionState = DECISION_BLOCKED;
          blockMessage = getBlockedMessage("unverified");
          deferred.resolve();
          return;
        }

        // Defense: Cart-Policy sagt "immer genau 1 Artikel". Bei Policy-Verletzung (>1 Item)
        // mit DUS-Bezug blocken wir den Checkout, statt einen DUS-Artikel in Koeln durchzulassen
        // oder beim cart/clear.js andere Artikel zu verlieren.
        if (items.length > 1 && dusItems.length > 0) {
          if (window.console && console.warn) {
            console.warn("localized-checkout: cart has", items.length, "items including DUS item; blocking checkout");
          }

          decisionState = DECISION_BLOCKED;
          blockMessage = getBlockedMessage("mixed");
          deferred.resolve();
          return;
        }

        if (dusItems.length > 0) {
          try {
            decisionState = DECISION_REDIRECT;
            redirectUrl = buildRedirectUrl(dusItems);
          } catch (error) {
            if (window.console && console.warn) {
              console.warn("localized-checkout: failed to build DUS checkout URL; blocking checkout", error);
            }

            decisionState = DECISION_BLOCKED;
            blockMessage = getBlockedMessage("unverified");
          }
        } else {
          decisionState = DECISION_NORMAL;
        }

        deferred.resolve();
      })
      .fail(function () {
        // Ohne cart.json keine verlaessliche Standort-Entscheidung - deshalb fail-closed.
        if (window.console && console.warn) {
          console.warn("localized-checkout: failed to load /cart.json; blocking checkout");
        }

        decisionState = DECISION_BLOCKED;
        blockMessage = getBlockedMessage("unverified");
        deferred.resolve();
      });

    return deferred.promise();
  }

  function isCheckoutForm(formElement) {
    if (!formElement) {
      return false;
    }

    var action = formElement.getAttribute("action") || "";
    var hasCheckoutInput = $(formElement).find("[name='checkout']").length > 0;

    return hasCheckoutInput && action.indexOf("/cart") !== -1;
  }

  function handleCheckoutAttempt(event, buttonElement, formElement) {
    if (nativeCheckoutInProgress) {
      return;
    }

    if (redirectInProgress || pendingButton) {
      if (event) {
        event.preventDefault();
      }
      return;
    }

    if (event) {
      event.preventDefault();
    }

    pendingButton = buttonElement || (formElement ? $(formElement).find(CHECKOUT_SELECTOR).get(0) : null);
    setButtonsBusy(true);

    // Wichtig: Die Entscheidung wird absichtlich bei jedem Checkout-Versuch frisch geladen.
    // Ein Page-Load-Snapshot kann stale sein, wenn der Warenkorb danach per AJAX geaendert wurde.
    loadDecision().always(function () {
      var buttonToContinue = pendingButton;
      pendingButton = null;

      if (decisionState === DECISION_REDIRECT) {
        pendingButton = buttonToContinue;
        redirectToDusCheckout();
        return;
      }

      if (decisionState === DECISION_BLOCKED) {
        blockCheckout(blockMessage || getBlockedMessage("unverified"));
        return;
      }

      setButtonsBusy(false);
      continueWithNativeCheckout(buttonToContinue);
    });
  }

  // Event delegation verhindert Timing-Probleme und deckt dynamische DOM-Updates ab.
  $(document)
    .off("click.localizedCheckout", CHECKOUT_SELECTOR)
    .on("click.localizedCheckout", CHECKOUT_SELECTOR, function (event) {
      handleCheckoutAttempt(event, this, this.form || null);
    })
    .off("submit.localizedCheckout", "form")
    .on("submit.localizedCheckout", "form", function (event) {
      if (!isCheckoutForm(this)) {
        return;
      }

      handleCheckoutAttempt(event, event.originalEvent && event.originalEvent.submitter, this);
    });
});
